import { useRef, useEffect } from 'react';

/**
 * Hook utilizzato per poter capire se un componente è ancora mounted (utilizzato nei processi
 * asincroni dopo la chiusura di un componente per evitare leak)
 * @returns elemento useRef contenente un boolean
 */
const useMountedRef = () => {
  const refMounted = useRef(true);
  useEffect(() => {
    refMounted.current = true;
    return () => {
      refMounted.current = false;
    };
  }, []);
  return refMounted;
};

export default useMountedRef;
